"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegendsContainer = exports.LegendWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const LegendsContainer = exports.LegendsContainer = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eba3ez51"
} : {
  target: "eba3ez51",
  label: "LegendsContainer"
})(props => /*#__PURE__*/(0, _react.css)("display:grid;grid-template-columns:", props.columns ? `repeat(${props.columns}, minmax(min-content, max-content))` : 'auto', ";justify-items:start;grid-column-gap:1em;margin:", `${props?.margin?.top}px ${props?.margin?.left}px ${props?.margin?.bottom}px ${props?.margin?.right}px`, ";@media screen and (max-width: ", _breakpoints.default.medium, "){grid-template-columns:auto;grid-template-rows:", props.columns ? `repeat(${props.columns}, 30px)` : 'auto', ";align-items:flex-start;justify-content:start;justify-items:start;}" + (process.env.NODE_ENV === "production" ? "" : ";label:LegendsContainer;")));
const LegendWrapper = exports.LegendWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eba3ez50"
} : {
  target: "eba3ez50",
  label: "LegendWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "bdj8j3",
  styles: "display:flex;align-items:center;text-align:center;>svg{margin-right:5px;}"
} : {
  name: "bdj8j3",
  styles: "display:flex;align-items:center;text-align:center;>svg{margin-right:5px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});